import styled from 'styled-components'
import { P } from 'ui/acro'

const CoachesList = styled(P)`
    font-family: ${(props) => props.theme.fonts.Proxima};
    color: ${(props) => props.theme.colors.black};
    text-transform: capitalize;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px; /* 128.571% */
    letter-spacing: 0.308px;
    white-space: normal;
    word-break: break-word;

    
    @media(min-width: 480px) {
      white-space: nowrap;
    }

)`
export default CoachesList
